import { useIntl } from "react-intl";
import { RSAKey } from "jsencrypt/lib/lib/jsbn/rsa";
import { CultureName } from "../components/constants/culture";
import { config } from "../Constants";

var PrivateKey = localStorage.getItem("privateKeyCookie");
var PublicKey = localStorage.getItem("publicKeyCookie");

const startTag = "<encrypt>",
  endTag = "</encrypt>";
const cryptico = window.cryptico;

function deserializeRSAKey(key) {
  try {
    let json = JSON.parse(key);
    let rsa = new RSAKey();
    rsa.setPrivateEx(
      json.n,
      json.e,
      json.d,
      json.p,
      json.q,
      json.dmp1,
      json.dmq1,
      json.coeff
    );
    return rsa;
  } catch (exceptionVar) {
    window.location.reload();
  }
}
function getCharactersInBetween(input, startsWith, endsWith) {
  let result = [];
  var inputLength;
  do {
    var startIndex = input.indexOf(startsWith);
    if (startIndex === -1) break;

    var endIndex = input.indexOf(endsWith) + endsWith.length;
    result.push(input.substring(startIndex, endIndex));
    inputLength = input.length;
    input = input.substring(endIndex);
  } while (endIndex < inputLength);
  return result;
}
function RemoveTags(input) {
  return input.replace(startTag, "").replace(endTag, "");
}
export function useFormatMessage(messageId) {
  return useIntl().formatMessage({ id: messageId });
}
export function encryptString(input) {
  return "<encrypt>" + cryptico.encrypt(input, PublicKey).cipher + "</encrypt>";
}

export function encryptStringWithoutTags(input) {
  return cryptico.encrypt(input, PublicKey).cipher;
}

export function encryptStringWithoutTagsForUser(input, doctorsPublicKey) {
  return cryptico.encrypt(input, doctorsPublicKey).cipher;
}

export function encryptStringForDoctor(input, doctorsPublicKey) {
  return (
    "<encrypt>" +
    cryptico.encrypt(input, doctorsPublicKey).cipher +
    "</encrypt>"
  );
}

export function decryptString(input) {
  var encryptedValues = getCharactersInBetween(input, startTag, endTag);
  var userPrivateKey = deserializeRSAKey(PrivateKey);
  if (encryptedValues.length) {
    //iterates over each data surrounded with specified tags and tries to replace with decrypted value
    for (var i = 0; i < encryptedValues.length; i++) {
      var decrypted = cryptico.decrypt(
        RemoveTags(encryptedValues[i]),
        userPrivateKey
      );
      if (decrypted.status === "success")
        input = input.replace(encryptedValues[i], decrypted.plaintext);
      else {
        input = input.replace(
          encryptedValues[i],
          RemoveTags(encryptedValues[i])
        );
      }
    }
  }
  return input;
}

export function decryptStringWithoutTags(input) {
  var userPrivateKey = deserializeRSAKey(PrivateKey);
  if (input.length) {
    //iterates over each data surrounded with specified tags and tries to replace with decrypted value
    for (var i = 0; i < input.length; i++) {
      var decrypted = cryptico.decrypt(input, userPrivateKey);
      if (decrypted.status === "success") {
        input = decrypted.plaintext;
      }
    }
  }
  return input;
}

export function getCurrency(culture) {
  if (culture === "da-DK") {
    return "kr.";
  } else {
    return "€";
  }
}

export function fixDate(input) {
  var datearray = [];
  var splitedChar = "";
  if (input.includes("-")) {
    datearray = input.split("-");
    splitedChar = "-";
  } else {
    datearray = input.split(".");
    splitedChar = ".";
  }
  if (datearray[0].length === 4) {
    input =
      datearray[2] + splitedChar + datearray[1] + splitedChar + datearray[0];
  } else {
    input =
      datearray[0] + splitedChar + datearray[1] + splitedChar + datearray[2];
  }
  if (datearray[0].length === 1) {
    datearray[0] = "0" + datearray[0];
    input =
      datearray[0] + splitedChar + datearray[1] + splitedChar + datearray[2];
  }
  if (datearray[1].length === 1) {
    datearray[1] = "0" + datearray[1];
    input =
      datearray[0] + splitedChar + datearray[1] + splitedChar + datearray[2];
  }
  let language = localStorage.getItem("lang");
  if (language === "en") {
    if (input.includes("-")) {
      input = input.replaceAll("-", ".");
    }
  } else {
    if (input.includes(".")) {
      input = input.replaceAll(".", "-");
    }
  }
  return input;
}

export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function fixDateBackEnd(input) {
  var datearray = [];
  var splitedChar = "";
  if (input.includes("-")) {
    datearray = input.split("-");
    splitedChar = "-";
  } else {
    datearray = input.split(".");
    splitedChar = ".";
  }
  input =
    datearray[1] + splitedChar + datearray[0] + splitedChar + datearray[2];
  return input;
}

export function getBookingDate(date) {
  const lang = localStorage.getItem("lang");
  let culture = CultureName.Danish;
  if (lang === CultureName.English.substring(0, 2)) {
    culture = CultureName.English;
  } else if (lang === CultureName.German.substring(0, 2)) {
    culture = CultureName.German;
  }
  const formatted = new Date(date)
    .toLocaleDateString(culture, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();
  return formatted.replace(/\./g, "");
}

export function timeDifference(start, end, dif, duration) {
  const startTime = new Date(start);
  const endTime = new Date(end);
  const differenceInMs = endTime.getTime() - startTime.getTime();
  if (duration * dif * 60 * 1000 !== differenceInMs) {
    return 0;
  }
  return differenceInMs;
}

export function validateCPRNumber(cprNumber, bday, gender, intl) {
  const response = {
    status: true,
    error: null,
  };

  const regex = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])\d{2}[-]?\d{4}$/gm;

  if (!regex.test(cprNumber)) {
    response.status = false;
    response.error = intl.formatMessage({ id: "CprNotValid" });
    return response;
  }

  const dd = bday.substr(0, 2);
  const mm = bday.substr(3, 2);
  const yy = bday.substr(8, 2);
  const cpr6digit = cprNumber.substr(0, 6);
  const cprGenderDigit = cprNumber.substr(10, 1);

  if (cpr6digit !== dd + mm + yy) {
    const cprdd = cprNumber.substr(0, 2);
    const cprmm = cprNumber.substr(2, 2);
    const cpryy = cprNumber.substr(4, 2);

    if (cprdd !== dd) {
      response.status = false;
      response.error = intl.formatMessage({ id: "DayCPRInvalid" });
      return response;
    } else if (cprmm !== mm) {
      response.status = false;
      response.error = intl.formatMessage({ id: "MonthCPRInvalid" });
      return response;
    } else if (cpryy !== yy) {
      response.status = false;
      response.error = intl.formatMessage({ id: "YearCPRInvalid" });
      return response;
    }

    response.status = false;
    response.error = intl.formatMessage({ id: "CprNotValid" });
    return response;
  }

  if (gender === "0" && cprGenderDigit % 2 === 0) {
    response.status = false;
    response.error = intl.formatMessage({ id: "CPRGenderInvalid" });
    return response;
  }

  if (gender === "1" && cprGenderDigit % 2 !== 0) {
    response.status = false;
    response.error = intl.formatMessage({ id: "CPRGenderInvalid" });
    return response;
  }

  return response;
}

export const getAddressDetails = async (addressString) => {
  const apiKey = config.url.GOOGLE_API_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    addressString
  )}&key=${apiKey}`;
  try {
    const res = await fetch(url);
    const data = await res.json();

    if (data.status === "OK") {
      return data;
    } else {
      console.warn("No results found:", data.status);
      return null;
    }
  } catch (error) {
    console.error("Geocoding error:", error);
    return null;
  }
};

export const fetchDanishSuggestions = async (address) => {
  try {
    const response = await fetch(
      `https://api.dataforsyningen.dk/autocomplete?q=${encodeURIComponent(
        address
      )}&per_side=10`
    );
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Fetch error:", err);
    return [];
  }
};
